export enum PROGRAM_TYPE_ENUM {
  PLG_SALES_ORG = 'PRP',
  ELOA_SALES_ORG = 'PB'
}